<template>
  <div class="home">
    <div class="bar" v-if="showBar">
      <div class="container-fluid">
        <div class="col-12 col-lg-10 search-area">
          <p class="m-0">En iyi deneyim için bilgisayar ile kullanın. <a href="#" class="btn btn-sm" @click.prevent="hideBar">Kapat &times;</a></p>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="col-12 col-lg-10 search-area">
        <div class="row">
          <div class="col-lg-6 col-12">
            <img class="logo" src="@/assets/logo-white.png" alt="Asonans: Türkçe asonans sözlüğü">
            <div class="on_hover">
              <h4 class="mt-0">asonans:</h4>
              <p>Ünlü harflerin aynı olması ile yapılan uyak.</p>

              <h6 class="mt-0 mb-0"><small class="text-muted">ÖRNEK</small></h6>
              <p class="example">
                Neyi sorarsam annem derdi: <span class="ass_1">"B<strong>a</strong>b<strong>a</strong>n<strong>a</strong> s<strong>o</strong>r!"</span> <br>
                Babama soramam babamın masada <span class="ass_1">v<strong>a</strong>r <strong>a</strong>n<strong>a</strong>s<strong>o</strong>n</span>
              </p>
              <p class="artist">Ceg - Neden</p>

              <h6 class="mt-0 mb-0"><small class="text-muted">ÖRNEK</small></h6>
              <p class="example" id="example_1">Piyancı <span class="ass_1">b<strong>i</strong>rd<strong>e</strong>n</span> <span class="ass_1">p<strong>o</strong>mp<strong>a</strong>l<strong>a</strong>r</span> <br>
                Flowlar <span class="ass_1">H<strong>e</strong>-M<strong>a</strong>n</span> <span class="ass_1"><strong>o</strong>lm<strong>a</strong>d<strong>a</strong>n</span> <br>
                Yazmam ben <span class="ass_1">f<strong>i</strong>kr<strong>e</strong>n</span> <span class="ass_1">d<strong>o</strong>lm<strong>a</strong>d<strong>a</strong>n</span> <br>
                Gördük biz <span class="ass_1">k<strong>i</strong>ml<strong>e</strong>r</span> <span class="ass_1">t<strong>o</strong>mb<strong>a</strong>l<strong>a</strong></span></p>
              <p class="artist">Anıl Piyancı, Ezhel - KAFA 10</p>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="text-right"><a class="btn btn-sm mt-lg-2 mb-lg-0 mb-2 text-light" href="https://twitter.com/demircancelebi" target="_blank">@demircancelebi</a></div>
          </div>
        </div>
        <div class="row">
          <div class="col-9 col-lg-10 pr-0">
            <input type="text" class="form-control form-control-sm text-white phrase" placeholder="dize sonunuzu yazın" v-model="phrase" @keyup.enter="find" data-hj-whitelist>
          </div>
          <div class="col-3 col-lg-2 d-flex align-items-center">
            <a class="btn btn-block btn-light bg-dark no-border" @click.prevent="find">Bul</a>
          </div>
        </div>
        <div class="row my-3 mb-5" v-if="calledFind">
          <div class="col-lg-3 col-6">
            <label for="" class="mb-1 lead">Ünlüleri bölüp ara: </label>
            <select name="" id="" v-model="variation" class="form-control form-control-sm bg-dark text-white" data-hj-whitelist>
              <option :value="v" v-for="v in variations" v-bind:key="v">{{ v }}</option>
            </select>
          </div>
          <div class="col-lg-3 col-6">
            <label for="" class="mb-1 lead">Sıraya koy: </label>
            <select name="" id="" v-model="sortBy" class="form-control form-control-sm bg-dark text-white" data-hj-whitelist >
              <option value="freq">Sıklığa göre diz</option>
              <option value="alph">Alfabetik diz (A-Z)</option>
              <option value="levo">Yazdığıma yakın olanlar üstte (beta)</option>
            </select>
          </div>
          <div class="col-lg-3 col-6" v-if="false">
            <label for="" class="mb-1 lead">&nbsp;</label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="deep" v-model="deep" data-hj-whitelist>
              <label class="form-check-label" for="deep">Derin ara</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="v in vars" class="col words-title" v-bind:key="v">
            <div class="row">
              <div class="col-2 pt-2 pr-0"><h6 class="mt-1">{{ v }}</h6></div>
              <div class="col p-1" data-toggle="tooltip" data-placement="top" title="Sözcük başlangıcına göre grupla">
                <select name="" id="" v-model="lensStart[v]" class="form-control form-control-sm bg-dark text-white" @change.prevent="groupWordsStart(v)" data-hj-whitelist>
                  <option :value="0">0</option>
                  <option :value="opt" v-for="opt in 6" v-bind:key="opt">{{ opt }}</option>
                </select>
              </div>
              <div class="col p-1" data-toggle="tooltip" data-placement="top" title="Sözcük sonuna göre grupla">
                <select name="" id="" v-model="lensEnd[v]" class="form-control form-control-sm bg-dark text-white" @change.prevent="groupWordsEnd(v)" data-hj-whitelist>
                  <option :value="0">0</option>
                  <option :value="opt" v-for="opt in 6" v-bind:key="opt">{{ opt }}</option>
                </select>
              </div>
              <div class="col p-1">
                <input type="text" class="form-control form-control-sm bg-dark text-white" placeholder="filtrele..." v-model="groupFilters[v]" @keyup="forceUpdate()" data-hj-whitelist>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="v in vars" class="col words" v-bind:key="v">
            <div v-if="filteredGroups(v).length === 0 && Object.keys(notFound).indexOf(v) === -1">...</div>
            <div v-if="filteredGroups(v).length === 0 && notFound[v]">{{ nope() }}</div>
            <div v-for="wk in filteredGroups(v)" v-bind:key="wk">
              <h5 class="bg-dark text-white" v-if="wk !== ''" @click.prevent="toggleCanSee(v, wk)" >{{ wk }} - <small>{{ grouped[v][wk].length }} sonucu gör</small></h5>
              <div class="the-word" v-for="word in grouped[v][wk]" v-if="canSee[v][wk]">
                <span class="freq">{{ freqs[word] }}</span>
                <span class="word" :class="{ 'selected': quicklist.indexOf(word) > -1 }" @click.prevent="toggleQuicklist(word, freqs[word])">{{ word }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-12">
        <div class="clear"><a class="btn btn-sm text-white" href="#" @click.prevent="quicklist = []">Temizle</a></div>
        <div class="quicklist bg-dark">
          <div class="the-word" v-for="(w, i) in quicklist" v-bind:key="w">
            <div class="freq">{{ freqlist[i] }}</div>
            <div class="word" @click.prevent="toggleQuicklist(w, freqlist[i])">{{ w }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery';
import levenshtein from 'fast-levenshtein';
import _ from 'lodash';

const $ = jQuery;
const isMobile = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

const recurse = (str) => {
  if (str.length === 1) {
    return str;
  }

  const arr = recurse(str.substring(0, str.length - 1));
  const res = [];

  for (let i = 0; i < arr.length * 2; i += 1) {
    res[i] = arr[i] + str[str.length - 1];
    if (i >= arr.length) {
      res[i] = `${arr[i % arr.length]} ${str[str.length - 1]}`;
    }
  }

  return res;
};

const getVariations = (str) => {
  const splen = str.split(' ').length;
  const condensed = str.replace(/\s/g, '');
  const arr = recurse(condensed);
  arr.sort((b, a) => Math.abs(splen - b.split(' ').length) > Math.abs(splen - a.split(' ').length));
  return arr;
};

const getVowels = (str) => {
  let vowels = '';

  for (let i = 0; i < str.length; i += 1) {
    if (['a', 'e', 'ı', 'i', 'o', 'ö', 'u', 'ü'].indexOf(str[i]) > -1) {
      vowels += str[i];
    }
  }

  return vowels;
};

// @ is an alias to /src
export default {
  name: 'home',
  mounted() {
    this.showBar = isMobile();
    $('body').tooltip({
      selector: '[data-toggle=tooltip]',
    });
  },
  methods: {
    hideBar() {
      this.showBar = false;
    },
    getVowels,
    getVariations(str) {
      return getVariations(str).map(st => st.replace(/\s/g, this.delimiter));
    },
    find() {
      this.calledFind = true;
      this.phrase = this.phrase.toLocaleLowerCase();
      const vowels = this.getVowels(this.phrase);
      const variations = this.getVariations(vowels);
      this.variations = variations;
      [this.variation] = variations;
    },
    sortWords(uniqVar) {
      const varDetails = this.varDetails[uniqVar];
      if (this.sortBy === 'levo') {
        varDetails.sort((b, a) => {
          const bDiff = typeof b[1] === 'undefined' ? 100 : levenshtein.get(this.phrase, b[1], { useCollator: true });
          const aDiff = typeof a[1] === 'undefined' ? 100 : levenshtein.get(this.phrase, a[1], { useCollator: true });
          return bDiff - aDiff;
        });
      } else if (this.sortBy === 'alph') {
        varDetails.sort((b, a) => (b[1] > a[1]) - 0.5);
      } else {
        varDetails.sort((b, a) => a[0] - b[0]);
      }
    },
    filteredGroups(v) {
      if (v in this.grouped) {
        return Object.keys(this.grouped[v]).filter(wk => wk.indexOf(this.groupFilters[v]) !== -1);
      }

      return [];
    },
    lastN(len) {
      return (str) => {
        if (typeof str !== 'undefined') {
          return str.substr(str.length - len - 1, str.length);
        }

        return '';
      };
    },
    firstN(len) {
      return (str) => {
        if (typeof str !== 'undefined') {
          return str.substr(0, len);
        }

        return '';
      };
    },
    toggleCanSee(v, wk) {
      this.canSee[v][wk] = !this.canSee[v][wk];
      this.$forceUpdate();
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    groupWordsStart(uniqVar) {
      const grouped = _.groupBy(this.varDetails[uniqVar].map(w => w[1]), this.firstN(this.lensStart[uniqVar]));
      const groupedSorted = Object.keys(grouped)
        .sort()
        .reduce((acc, key) => ({
          ...acc, [key]: grouped[key],
        }), {});

      this.grouped[uniqVar] = groupedSorted;
      Object.keys(groupedSorted).forEach((wk) => {
        if (!(uniqVar in this.canSee)) {
          this.canSee[uniqVar] = {};
        }
        this.canSee[uniqVar][wk] = this.lensStart[uniqVar] === 0;
      });
      this.$forceUpdate();
    },
    groupWordsEnd(uniqVar) {
      const grouped = _.groupBy(this.varDetails[uniqVar].map(w => w[1]), this.lastN(this.lensEnd[uniqVar]));
      const groupedSorted = Object.keys(grouped)
        .sort()
        .reduce((acc, key) => ({
          ...acc, [key]: grouped[key],
        }), {});

      this.grouped[uniqVar] = groupedSorted;
      Object.keys(groupedSorted).forEach((wk) => {
        if (!(uniqVar in this.canSee)) {
          this.canSee[uniqVar] = {};
        }
        this.canSee[uniqVar][wk] = this.lensEnd[uniqVar] === 0;
      });
      this.$forceUpdate();
    },
    toggleQuicklist(word, freq) {
      const ind = this.quicklist.indexOf(word);
      if (ind > -1) {
        this.quicklist.splice(ind, 1);
        this.freqlist.splice(ind, 1);
      } else {
        this.quicklist.push(word);
        this.freqlist.push(freq);
      }
    },
    fetchVariations(vars) {
      const varsUniq = [...new Set(vars)];
      varsUniq.forEach((uniqVar) => {
        if (!(uniqVar in this.varDetails)) {
          const varUri = uniqVar.replace(/ö/g, 'o%CC%88').replace(/ü/g, 'u%CC%88');
          fetch(`https://s3-eu-west-1.amazonaws.com/demircan/asonans/${varUri}.csv`)
            .then((response) => {
              if (response.ok) {
                return response.text();
              }
              this.notFound[uniqVar] = true;
              this.$forceUpdate();
              return false;
            })
            .then((response) => {
              if (response) {
                const varDetails = response.split('\n').slice(1).map(s => s.split(','));
                this.varDetails[uniqVar] = varDetails;
                this.lensEnd[uniqVar] = 0;
                this.lensStart[uniqVar] = 0;
                this.groupFilters[uniqVar] = '';
                this.sortWords(uniqVar);
                this.varDetails[uniqVar].forEach((w) => {
                  this.freqs[w[1]] = w[0];
                });
                this.groupWordsEnd(uniqVar);
                this.$forceUpdate();
              }
            });
        } else {
          this.sortWords(uniqVar);
        }
      });
    },
    nope() {
      const words = [`¯\\_(ツ)_/¯`];
      return words[Math.floor(Math.random() * words.length)];
    },
  },
  watch: {
    variation(newVariation) {
      if (!this.deep) {
        this.vars = newVariation.split(this.delimiter);
      } else {
        const vars = newVariation.split(this.delimiter);
        this.vars = vars;
      }
      this.fetchVariations(this.vars);
    },
    sortBy() {
      this.vars.forEach((uniqVar) => {
        this.sortWords(uniqVar);
        this.groupWordsEnd(uniqVar);
      });
    },
  },
  data() {
    return {
      sortBy: 'freq',
      phrase: '',
      delimiter: '-',
      variation: '',
      vars: [],
      quicklist: [],
      freqlist: [],
      variations: [],
      notFound: {},
      varDetails: {},
      grouped: {},
      freqs: {},
      lensStart: {},
      lensEnd: {},
      canSee: {},
      groupFilters: {},
      deep: false,
      showBar: true,
      calledFind: false,
    };
  },
};
</script>

<style lang="scss">
$wlen: 190px;
$w: $wlen * 6;
  .search-area {
    @media (min-width: 768px) {
      padding-left: 70px !important;
    }
  }
  .form-control {
    border: none !important;
    outline: none !important;
  }
  .logo {
    margin: -30px auto 0 -30px;
    @media (max-width: 768px) {
      max-width: 100%;
      padding-top: 10px;
    }
    max-width: $w/2.75;
    display: block;
  }

  .phrase[type="text"] {
    height: 40px;
    // width: $w - 330px;
    border: none;
    font-size: 18px;
    padding: 10px;
    outline: none;
    background: transparent;
    color: #fff;
    border-bottom: 2px solid #333 !important;
    border-radius: 0 !important;
    &:focus {
      background: transparent;
      outline: none !important;
      box-shadow: none !important;
      border-bottom: 2px solid #ff8a00 !important;
    }
  }
  .no-border {
    border: none !important;
  }
  .ass_0 {
    strong {
      border-bottom: 1px solid #0f5fe2;
    }
    padding: 2px 7px 2px 5px;
    /*border-radius: 5px;*/
    color: #0f5fe2;
  }
  .ass_1 {
    strong {
      border-bottom: 1px solid #ff8a00;
    }
    padding: 2px 7px 2px 5px;
    /*border-radius: 5px;*/
    color: #ff8a00;
  }
  .on_hover .artist {
    background: #ff8a00;
    color: #222 !important;
    border-radius: 2px;
    display: inline-block;
    padding: 4px 6px;
    font-weight: 700;
    margin-top: 5px;
    margin-bottom: 20px;
  }
  p {
    margin: 0 0 20px;
    font-weight: 300;
    line-height: 1.5;
    color: rgba(255,255,255,0.7);
  }
  .example {
    font-style: italic;
    font-size: 22px;
    line-height: 34px;
    margin-bottom: 0;
  }
  .on_hover {
    display: none;
    position: absolute;
    // margin-left: 60px;
    // margin-top: -30px;
    padding: 0;
    width: 100%;
    z-index: 2;
    padding: 10px;
    background: #333;
    color: #fff !important;
    p {
      color: #fff !important;
    }
  }
  .logo:hover ~ .on_hover{
    display: block;
  }
  .mb-0 {
    margin-bottom: 0;
  }
  .mt-0 {
    margin-top: 0;
  }
  .results {
    margin-top: 20px;
    width: $w;
    /*letter-spacing: 15px;*/
  }

  .main-letter {
    display: inline-block;
    width: $wlen;
    font-size: 18px;
    font-weight: 600;
    // text-align: center;
  }
  $words_h: 400px;
  .words {
    height: $words_h;
    padding: 0 0 0 75px !important;
    margin: 0 0 0 -60px !important;
    overflow-y: scroll;
    overflow-x: auto;
    margin-bottom: 50px;
  }
  .words-title {
    border-bottom: 1px dotted rgba(255,255,255,0.3);
  }
  .the-word {
    position: relative;
    .freq {
      position: absolute;
      margin-left: -70px;
      z-index: 100;
      display: none;
    }
    &:hover {
      .freq {
        display: block;
      }
    }
  }
  .word {
    cursor: pointer;
    width: 100%;
    display: block;
    &:hover, &.selected {
      font-weight: bold;
      color: #fff;
    }
  }
  @media (min-width: 768px) {
    $ql: 92px;
    .quicklist {
      position: fixed;
      top: $ql;
      right: 20px;
      min-width: 200px;
      border-radius: 4px;
      padding: 3px 0 3px 75px;
      height: $words_h + 162;
      overflow: scroll;
      .the-word {
        width: 100%;
      }

      .freq {
        display: block;
      }
    }
    .clear {
      position: fixed;
      top: $ql - 34;
      right: 25px;
    }
  }
  @media (max-width: 768px) {
    $ql: 92px;
    .quicklist {
      position: fixed;
      top: 550px;
      // right: 20px;
      width: 100%;
      left: 0;
      border-radius: 0;

      padding: 3px 0 3px 75px;
      height: 140px;
      overflow: scroll;
      .the-word {
        width: 50%;
        float: left;
      }

      .freq {
        display: block;
      }
    }
    .clear {
      position: fixed;
      top: 550px;
      right: 5px;
      z-index: 1000;
    }
  }
  .space {
    height: 30px;
    width: 2px;
    margin: 0 24px;
    display: inline-block;
    top: -5px;
    position: relative;
    background: #333;
  }
  .bar {
    background: #ff8a00;
    p {
      color: #333;
    }
    padding: 10px;
    a {
      position: relative;
      z-index: 1000;
    }
  }
</style>
